var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64914 22.0366C10.5157 22.0366 12.0287 20.5235 12.0287 18.657V15.2773H8.64914C6.78261 15.2773 5.26953 16.7905 5.26953 18.657C5.26953 20.5235 6.78261 22.0366 8.64914 22.0366Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26953 11.8952C5.26953 10.0287 6.78261 8.51562 8.64914 8.51562H12.0287V15.2748H8.64914C6.78261 15.2748 5.26953 13.7617 5.26953 11.8952Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26953 5.13743C5.26953 3.2709 6.78261 1.75781 8.64914 1.75781H12.0287V8.51704H8.64914C6.78261 8.51704 5.26953 7.00389 5.26953 5.13743Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0273 1.75781H15.407C17.2735 1.75781 18.7866 3.2709 18.7866 5.13743C18.7866 7.00389 17.2735 8.51704 15.407 8.51704H12.0273V1.75781Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7866 11.8952C18.7866 13.7617 17.2735 15.2748 15.407 15.2748C13.5404 15.2748 12.0273 13.7617 12.0273 11.8952C12.0273 10.0287 13.5404 8.51562 15.407 8.51562C17.2735 8.51562 18.7866 10.0287 18.7866 11.8952Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.28395979ddd5fd204154067c4b5d4efb.svg";
export { ForwardRef as ReactComponent };